export const FORMSATTR = {
  phone_number: {
    rules: { minLength: 3, maxLength: 9, type: 'integer' },
    value: '',
    status: [[{ id: 'minLength' }, { min: '3' }]],
  },
  email: {
    rules: { minLength: 3, maxLength: 40, type: 'email' },
    value: '',
    status: [[{ id: 'minLength' }, { min: '3' }]],
  },
  supplier_id: {
    rules: { minLength: 3, maxLength: 30, type: 'string' },
    value: '',
    status: [[{ id: 'minLength' }, { min: '3' }]],
  },
  templateName: {
    rules: { minLength: 3, maxLength: 30, type: 'string' },
    value: '',
    status: [[{ id: 'minLength' }, { min: '3' }]],
  },
};

export const TABLEATTR = [
  'provider',
  'docket_number',
  'reference_number',
  'compressive_strength',
];
